export default __webpack_public_path__ + "static/media/lets-form-company.d98dcca9.svg";